




















































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { DxDataGrid, DxColumn, } from 'devextreme-vue/data-grid';
import { List } from 'linqts'
import moment from "moment";

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import { EstadisticasService } from '@/services/EstadisticasService';
import { Sorteo } from '@/model/Sorteo';
import GenericService from '@/services/GenericService';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
  },
})
export default class SorteoEstadisticaComparativaHistorico extends Vue {
  estadisticasService: any | EstadisticasService = new EstadisticasService();
  
  sorteoService: any | GenericService<Sorteo> = new GenericService<Sorteo>("Sorteo");
  sorteo: any | Sorteo = {};

  datasource: any = [];

  items: any = [];

  selectPrimero: string = "";
  selectSegundo: string = "";

  sorteos: List<Sorteo> = new List<Sorteo>();

  columns: any = [];
  width: string = "100%";
  height: number = 500;
  headerFilter: any = { visible: true };

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift(
    {
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        onClick: () => {
          this.load();
        }
      }
    });
  }

  mounted(){
    this.sorteoService.getAll().then((res: Array<Sorteo>) => {
      this.sorteos = new List<Sorteo>(res);

      for (let index = 0; index < res.length; index++) {
        const element = res[index];
        this.items.push(element.Titulo)
      }
    })
    eventService.on("SorteoDetailLoaded", (res: Sorteo) =>{
      this.sorteo = res;
      this.selectPrimero = this.sorteo.Titulo;
    });
  }

  destroyed(){
    eventService.off("SorteoDetailLoaded");
    this.selectPrimero = "";
    this.selectSegundo = "";
    this.sorteo = undefined;
  }

  load(){    
    logService.Info("Inicio - Sorteo: "+this.sorteo.Id,"SorteoEstadisticaComparativaHistorico.vue - load()");
    eventService.emit("LoadPanel", true);
    if(this.selectPrimero !== "" && this.selectSegundo !== ""){
      let idPrimero = this.sorteos.FirstOrDefault(x => x !== undefined && x.Titulo === this.selectPrimero).Id;
      let idSegundo = this.sorteos.FirstOrDefault(x => x !== undefined && x.Titulo === this.selectSegundo).Id;

      this.estadisticasService.CalcularComparativoHistorico(idPrimero,idSegundo).then((res: any) => {
        this.datasource = res;
        eventService.emit("LoadPanel", false);
      })
      this.columns = [
        {
          caption: this.selectPrimero,
          columns: [
            {
              dataField: "DiaAnyo",
              caption: "FECHA",
              sortOrder: "desc"
            },
            {
              dataField: "NumerosDiaPrimero",
              caption: "NÚMEROS DIA"
            },
            {
              dataField: "NumerosTotalSorteoPrimero",
              caption: "NÚMEROS TOTAL SORTEO"
            },
          ]
        },
        {
          caption: this.selectSegundo,
          columns: [
            {
              dataField: "DiaAnyo",
              caption: "FECHA",
            },
            {
              dataField: "NumerosDiaSegundo",
              caption: "NÚMEROS  DIA"
            },
            {
              dataField: "NumerosTotalSorteoSegundo",
              caption: "NÚMEROS TOTAL SORTEO"
            },
          ]
        },
        {
          caption: "DIFERENCIA",
          columns: [
            {
              dataField: "DiferenciaDia",
              caption: "DIFERENCIA"
            },
            {
              dataField: "DiferenciaTotalSorteo",
              caption: "TOTAL"
            }
          ]
        },
      ]
    }else{
      logService.Info("Debe seleccionar dos sorteos - Sorteo: "+this.sorteo.Id,"SorteoEstadisticaComparativaHistorico.vue - load()");
      toastService.warning("Debe seleccionar dos sorteos.");
    }
  }
}
